export const relations = [
  'Child',
  'Parent',
  'Grandparent',
  'Grandchild',
  'Sibling',
  'Aunt',
  'Uncle',
  'Cousin',
  'Nephew',
  'Niece',
  'In-Law',
  'Step-Sibling',
  'Step-Parent',
  'Step-Grandparent',
  'Friend',
  'Charity',
  'Other',
];
